import React from "react";
import { Card, CardBody } from "reactstrap";

const SemaforoFallas = () => {
  const estados = [
    { color: "rgb(62, 165, 138)", text: "Dentro del rango" },
    { color: "rgb(183, 211, 87)", text: "Cerca del límite"},
    { color: "rgb(226, 93, 55)", text: "Fuera del rango"},
  ];

  return (
    <Card className="h-100 rounded-4">
      <CardBody className="p-2">
        <h6 className="mb-2 text-center fw-bold">Semáforo de Fallas</h6>
        <div className="d-flex flex-column gap-1">
          {estados.map((estado, index) => (
            <div key={index} className="d-flex align-items-center">
              <div
                className="rounded-circle me-2"
                style={{
                  width: "12px",
                  height: "12px",
                  backgroundColor: estado.color,
                }}
              ></div>
              <div className="flex-grow-1">
                <small className="text-muted">{estado.text}</small>
              </div>
            </div>
          ))}
        </div>
      </CardBody>
    </Card>
  );
};

export default SemaforoFallas;
